import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type SmartReviewNoHistoryProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SmartReviewNoHistory = ({
  isOpen,
  onClose,
}: SmartReviewNoHistoryProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content size="small">
        <StatusModal
          type="warning"
          title="No categorisation history to run smart review"
          showCloseButton={false}
        >
          We use your past categorisation history to smart review the
          transactions. Once you've categorised a few transactions manually,
          we'll start recognising patterns and do the review.
        </StatusModal>
        <Modal.Footer>
          <div className="t-flex t-justify-end">
            <Button customType="primary" onClick={onClose}>
              Got it
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
